export default __webpack_public_path__ + "static/tech-rackspace-c5f31b85f37c8f063afb33082fb5d7a2-c5f31b85f37c8f063afb33082fb5d7a2.png";